package com.devi3east.bashbuddy.exceptions

import kotlinx.serialization.Serializable

@Serializable
data class InventoryErrorResponse(
    val errorMessage: String,
    val ticketId: String? = null,
    val requestedQuantity: Int? = null,
    val availableQuantity: Int? = null
)